import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import { getToken, getClientDomain, round, translate } from '../../../../utils/Common';
import { useForm } from 'react-hook-form';
import { FormGrid, Field } from "@/components/ui/form-field";
import { SwitchField } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import AuthContext from '../../../../contexts/auth';
import ModalContext from '../../../../contexts/modal';
// components
import FieldSizes from "./FieldSizes";
import LockerSizes from "./LockerSizes";
import SearchClient from "./SearchClient";
import PlatformList from '../../../../components/PlatformList';
import DoorList from '../../../../components/DoorList';
import ProviderList from '../../../../components/ProviderList';
import { usePackages } from '../../../../hooks/usePackages';
import PlatformSearchList from '../../../../components/PlatformSearchList';
import ClientsSearchList from '../../../../components/ClientsSearchList';

// formulario para carga tipo proveedor
const FormProveedores = (props) => {
    const userContext = useContext(AuthContext);
    const modalContext = useContext(ModalContext);
    const { register, errors, clearErrors, setError, reset, handleSubmit, watch, setValue } = useForm();
  const {createPackage} = usePackages();
    // para saber qué unidades de medida utilizar --> 0 = cm/kg, 1 = inch/lb
    const [unidad, setUnidad] = useState(1);
    // para saber el tipo de ingreso de medidas
    const [ingresarMedidas, setIngresarMedidas] = useState(false);

    // calcular el precio total
    const [precioLibra, setPrecioLibra] = useState(0);
    const [cargoAduana, setCargoAduana] = useState(0);
    const [otrosCargos, setOtrosCargos] = useState(0);
    // calcular peso
    const [pesoReal, setPesoReal] = useState(0);
    const [pesoVol, setPesoVol] = useState(0);
    
    // variables usadas para la busqueda del cliente
    const [providor, setProvidor] = useState(null);
  const [platformSelect, setPlatformSelect] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);

    // para saber qué boxit se seleccionó
    const [isBoxit, setIsBoxit] = useState(false);
    const idPlatform = useRef({});
    idPlatform.current = watch("plataforma","");
    const handleIsBoxit = useCallback((value) => setIsBoxit(value), []);

    // clear formulario
    const resetFormProveedores = () => {
        reset();
        clearErrors();

        setIngresarMedidas(false);
        setUnidad(1);
        setPrecioLibra(0);
        setCargoAduana(0);
        setOtrosCargos(0);
        setPesoReal(0);
        setPesoVol(0);
        setIsBoxit(false);
        setSelectedClient(null);
    }
    
    const [isSendingData, setIsSendingData] = useState(false);
    // registrar paquete en el servidor
    const sendPackage = async (data) => {
        try {
            if (!props?.canCreate) return;
            setIsSendingData(true);
            if (!selectedClient) {
                setError('buscarCliente', {
                    type: '',
                    message: translate("dashboard.packages.loadpackage.formProvider.searchClient")
                });
                return;
            }

            // validar peso
            let pesoRealValidator = false;
            let pesoVolValidator = false;
            if (!userContext.user?.IsAdmin) {
                let precioLb = false;
                data.proveedor = userContext.user?.Ruc;                
                data.idTipoUsuario = userContext.user?.IdTipoUsuario;

                if (!data.pesoReal || data.pesoReal === "0") {
                    setError('pesoReal', {
                        type: '',
                        message: translate("dashboard.packages.loadpackage.formProvider.weightLb")
                    });
                    pesoRealValidator = true;
                }
                
                if (!data.pesoVol || data.pesoVol === "0") {
                    setError('pesoVol', {
                        type: '',
                        message: translate("dashboard.packages.loadpackage.formProvider.weightVol")
                    });
                    pesoVolValidator = true;
                }

                if (data.precioLibra === "0") {
                    setError('precioLibra', {
                        type: '',
                        message: translate("dashboard.packages.loadpackage.formProvider.costLb")
                    });
                    precioLb = true;
                }
                
                if (pesoRealValidator || pesoVolValidator || precioLb) return;
            }
            else {
                data.proveedor = providor?.IdUsuario;
                data.idTipoUsuario = providor?.IdTipoUsuario;

                if (!data.pesoReal) {
                    setError('pesoReal', {
                        type: '',
                        message: translate("dashboard.packages.loadpackage.formProvider.weightLb")
                    });
                    pesoRealValidator = true;
                }
                
                if (!data.pesoVol) {
                    setError('pesoVol', {
                        type: '',
                        message: translate("dashboard.packages.loadpackage.formProvider.weightVol")
                    });
                    pesoVolValidator = true;
                }
                
                if (pesoRealValidator || pesoVolValidator) return;

                data.cliente = selectedClient ? selectedClient : ""
            }

            // validar datos a enviar
            if (data.pesoVol > 25) {
                if (data.pesoVol > data.pesoReal) data.peso = data.pesoVol;
                else data.peso = data.pesoReal;
            }
            else {
                data.peso = data.pesoReal;
            }
            if (data.puerta) {
                if (data.puerta === 'No hay puertas disponibles' || data.puerta === 'Seleccione') data.puerta = '';
            }
            if (unidad) {
                if (data.alto) data.alto = round(data.alto * 2.54, 2);
                if (data.largo) data.largo = round(data.largo * 2.54, 2);
                if (data.ancho) data.ancho = round(data.ancho * 2.54, 2);
            }
            else {
                if (data.peso) data.peso = Math.ceil(data.peso * 2.205);
            }

            data.idTipoPaquete= props.idTipoPaquete 

            const controller = new AbortController();
            const result = await createPackage(data, controller.signal);

            if (result) {
                if (result.code === 200) {
                    if (result.payload.Procesado === '1') {
                        modalContext.confirm(
                            translate("dashboard.packages.loadpackage.formProvider.successTittle"), 
                            result.payload.PackageNumber ? (
                                <div>
                                      {translate("dashboard.packages.loadpackage.formProvider.successInfo")}
              
                                      <div>
                                          {translate("global.numPackageIs")} <span style={{ fontWeight: "bold" }}>{result.payload.PackageNumber}</span>
                                      </div>
                                  
                                </div>
                              ) : (
                                translate(
                                  "dashboard.packages.loadpackage.formProvider.successInfo"
                                )),
                            <Button type="button" variant="outline-secondary" size="sm" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</Button>,
                            true);
                        resetFormProveedores();
                    } if(result.payload.Mensaje==="RESERVATION MADE SUCCESSFULLY"){
                        modalContext.confirm(
                          translate(
                            "dashboard.packages.loadpackage.formProvider.successTittle"
                          ),
                          <div>
                            {translate("dashboard.packages.loadpackage.formProvider.successInfoReserved")}
                            <div>{translate("global.status.reservedDoor")} : <span style={{fontWeight:"bold"}}>{result.payload.Locker}</span></div>
                          </div>,
                          <Button
                            type="button"
                            variant="secondary" size="sm"
                            onClick={() => modalContext.setIsOpenModal(false)}
                          >
                            {translate("global.accept")}
                          </Button>,
                          true
                        );
                        resetFormProveedores();
                      } 
                    else {
                        const errorHandlers = {
                            'El número de paquete ya se encuentra registrado.': () => setError('paquete', { type: '', message: translate("dashboard.packages.loadpackages.formProvider.packageRegistered") }),
                            'El número de tracking ya se encuentra registrado.': () => setError('tracking', { type: '', message: translate("dashboard.packages.loadpackages.formProvider.trackingRegistered") }),
                            'No tienes autorización para entregar en este Boxit.': () => setError('plataforma', { type: '', message: translate("dashboard.packages.loadpackages.formProvider.notAuthorized") })
                        };

                        const errorMessage = result.payload.Mensaje;
                        if (errorHandlers[errorMessage]) {
                                errorHandlers[errorMessage]();
                        }
                    }
                }
                else modalContext.confirm(
                    translate("global.alerts.ops"), 
                    translate("dashboard.packages.loadpackages.formProvider.errorRegisterPackage"),
                    <Button type="button" variant="outline-secondary" size="sm" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</Button>,
                    true);
            }
        } catch (err) {
            console.log(err);
            modalContext.confirm(
                translate("global.alerts.ops"), 
                translate("dashboard.packages.loadpackages.formProvider.errorRegisterPackage"),
                <Button type="button" variant="outline-secondary" size="sm" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</Button>,
                true);
        } finally {
            setIsSendingData(false);
        }
    }

    // calcular el monto total
    const [costoTotal, setCostoTotal] = useState(0);
    useEffect(() => {
        let peso = 0;
                
        if (pesoVol > 25) {
            if (pesoVol > pesoReal) peso = pesoVol;
            else peso = pesoReal;
        }
        else {
            peso = pesoReal;
        }

        setCostoTotal(otrosCargos + cargoAduana + round((precioLibra * (unidad ? peso : Math.ceil(peso * 2.205))), 2));
    }, [otrosCargos, cargoAduana, precioLibra, pesoReal, pesoVol, unidad]);

    return (
        <>
            <form className="carga-proveedores m-0 p-0" onSubmit={ handleSubmit(sendPackage) }>
            {props?.canSearch && userContext.user?.IsAdmin && (
                <FormGrid className="mt-4">
                    <Field
                        span={6}
                        id="selectProveedor"
                        label={translate("global.business")}
                        required
                    >
                        <ProviderList
                            register={register}
                            errors={errors}
                            nameShow={translate("global.select")}
                            idShow={props.idTipoUsuario}
                            readOnly={false}
                            setValue={setValue}
                            valueId={"proveedor"}
                            setProveedor={setProvidor}
                        />
                    </Field>

                    {providor && (
                        <Field
                            span={6}
                            id="selectCliente"
                            label={translate("global.client")}
                            required
                        >
                            <ClientsSearchList
                                idUsuarioSelected={providor?.value}
                                errors={errors}
                                setError={setError}
                                clearErrors={clearErrors}
                                register={register}
                                idTipoCliente={props.idTipoCliente}
                                setSelectOption={setSelectedClient}
                                autoSelectClient
                            />
                        </Field>
                    )}
                </FormGrid>
            )}

                <FormGrid className="mt-4">
                    <Field
                        span={6}
                        id="inputNumeroPaquete"
                        name="paquete"
                        label={translate("dashboard.packages.loadpackages.formProvider.numPackage")}
                        required
                        error={errors.paquete}
                        inputRef={register({
                            required: {
                                value: true,
                                message: translate("global.error.notValidPackages")
                            }
                        })}
                    />

                    <Field
                        span={6}
                        id="inputNumeroTracking"
                        name="tracking"
                        label={translate("dashboard.packages.loadpackages.formProvider.numTracking")}
                        required
                        error={errors.tracking}
                        inputRef={register({
                            required: {
                                value: true,
                                message: translate("dashboard.packages.loadpackages.formProvider.notValidTracking")
                            }
                        })}
                    />
                </FormGrid>

                <FormGrid className="mt-4">
                    <Field
                        span={8}
                        as="textarea"
                        rows="2"
                        id="inputDescripcion"
                        name="descripcion"
                        label={translate("global.description")}
                        hint={`(${translate("global.optional")})`}
                        inputRef={register}
                    />

                    <SwitchField
                        span={4}
                        id="inputTipoIngresoMedidas"
                        label={translate("dashboard.packages.loadpackages.formProvider.packageMeasures")}
                        checked={ ingresarMedidas }
                        onCheckedChange={ setIngresarMedidas }
                    />
                </FormGrid>

                <FormGrid className="mt-4">
                    <Field
                        span={4}
                        id="inputCourier"
                        name="courier"
                        label={translate("global.courier")}
                        hint={`(${translate("global.optional")})`}
                        inputRef={register}
                    />

                    {ingresarMedidas && (
                        <Field
                            span={3}
                            as="select"
                            id="selectSistemaMedida"
                            label={translate("global.units")}
                            onChange={ (e) => setUnidad(e.target.value === 'cm / kg' ? 0 : 1) }
                        >
                            <option>inch / lb</option>
                            <option>cm / kg</option>
                        </Field>
                    )}

                    <Field
                        span={2}
                        type="number"
                        id="inputPesoReal"
                        name="pesoReal"
                        placeholder="0"
                        label={`${translate("global.weight")} (${unidad === 0 ? 'kg' : 'lb'})`}
                        required
                        error={errors.pesoReal}
                        onChange={ (e) => setPesoReal(e.target.value ? e.target.value : 0) }
                        inputRef={register}
                    />

                    <Field
                        span={2}
                        type="number"
                        id="inputPesoVol"
                        name="pesoVol"
                        placeholder="0"
                        label={`${translate("global.weight")} (vol)`}
                        required
                        error={errors.pesoVol}
                        onChange={ (e) => setPesoVol(e.target.value ? e.target.value : 0) }
                        inputRef={register}
                    />

                    {!ingresarMedidas && (
                        <Field
                            span={2}
                            as="select"
                            id="selectTamano"
                            name="size"
                            label={translate("global.size")}
                            inputRef={register()}
                        >
                            <option>P</option>
                            <option>M</option>
                            <option>G</option>
                        </Field>
                    )}
                </FormGrid>

                { ingresarMedidas &&
                    <FieldSizes register={ register }
                                unidad={ unidad } />
                }

                <FormGrid className="mt-4">
                    <Field span={6} id="selectBoxit" label="Boxit" required>
                        <PlatformSearchList
                            register={register}
                            errors={errors}
                            setPlatformSelect={setPlatformSelect}
                            platfSelect={platformSelect}
                            valueId={"plataforma"}
                            readOnly={false}
                            setValue={setValue}
                            idPlatform={idPlatform.current}
                            handleIsBoxit={handleIsBoxit}
                            defaultPlatformId={props.idPlatformSelect}
                        />
                    </Field>

                    {userContext.user?.IsAdmin && isBoxit && idPlatform.current !== 'Seleccione' && idPlatform.current !== '' &&
                        <Field
                            span={6}
                            id="selectPuertas"
                            label={translate("dashboard.packages.loadpackages.formProvider.doorsAvailable")}
                        >
                            <DoorList
                                errors={ errors }
                                register={ register }
                                nameShow={translate("global.select")}
                                idShow={ idPlatform.current }
                                readOnly={ false }
                                isBoxit />
                        </Field>
                    }
                </FormGrid>

                <FormGrid className="mt-4">
                    { userContext.user?.IsAdmin &&
                        <Field
                            span={3}
                            type="number"
                            step=".01"
                            id="inputOtrosCargos"
                            name="otrosCargos"
                            placeholder="0"
                            label={`${translate("dashboard.packages.loadpackages.formProvider.othersCharges")} (B/)`}
                            error={errors.otrosCargos}
                            onChange={ (e) => setOtrosCargos(Number(e.target.value ? e.target.value : 0)) }
                            inputRef={register}
                        />
                    }

                    <Field
                        span={3}
                        type="number"
                        step=".01"
                        id="inputCargoAduanas"
                        name="cargoAduana"
                        placeholder="0"
                        label={`${translate("dashboard.packages.loadpackages.formProvider.customsCharge")} (B/)`}
                        error={errors.cargoAduana}
                        onChange={ (e) => setCargoAduana(Number(e.target.value ? e.target.value : 0)) }
                        inputRef={register}
                    />

                    <Field
                        span={3}
                        type="number"
                        step=".01"
                        id="inputPrecio"
                        name="precioLibra"
                        placeholder="0"
                        label={`${translate("dashboard.packages.loadpackages.formProvider.costLb")} (B/)`}
                        required
                        error={errors.precioLibra}
                        onChange={ (e) => setPrecioLibra(Number(e.target.value ? e.target.value : 0)) }
                        inputRef={register({
                            required: {
                                value: true,
                                message: translate("dashboard.packages.loadpackages.formProvider.costLb.message")
                            }
                        })}
                    />

                    <Field
                        span={3}
                        type="number"
                        step=".01"
                        id="inputCostoProv"
                        name="costoProv"
                        placeholder="0"
                        label={`${translate("dashboard.packages.loadpackages.formProvider.costTotal")} (B/)`}
                        value={ costoTotal }
                        readOnly
                        error={errors.costoProv}
                        className="bg-muted/30 font-semibold"
                        inputRef={register}
                    />
                </FormGrid>

                <div className="mt-6 flex flex-col-reverse justify-center gap-3 sm:flex-row">
                    <Button type="reset" variant="outline-secondary" onClick={ () => resetFormProveedores() }>
                        {translate("global.clean")}
                    </Button>
                    {props?.canCreate && (
                        <Button type="submit" variant="secondary" disabled={ isSendingData }>
                            {translate("global.toRegister")}
                        </Button>
                    )}
                </div>

                <LockerSizes unidad={ unidad } />
    
            </form>
        </>
    );
}

export default FormProveedores;